import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-thick-circle-bottom-right-corner': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M20.485 3.515a12 12 0 1 0 0 16.97 12.015 12.015 0 0 0 0-16.97zM7.554 16.446l2.678-2.678a.25.25 0 0 0 0-.354L5.815 8.992a.5.5 0 0 1 0-.707l2.47-2.47a.5.5 0 0 1 .707 0l4.419 4.42a.25.25 0 0 0 .354 0l2.679-2.679a.5.5 0 0 1 .854.353V16.8a.5.5 0 0 1-.5.5h-8.89a.5.5 0 0 1-.354-.854z"/>`,
    },
});
